if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // onSubmitHandler(evt) {
      //   evt.preventDefault();
      //   if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      //   this.handleErrorMessage();

      //   this.submitButton.setAttribute('aria-disabled', true);
      //   this.submitButton.classList.add('loading');
      //   this.querySelector('.loading__spinner').classList.remove('hidden');

      //   const config = fetchConfig('javascript');
      //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
      //   delete config.headers['Content-Type'];

      //   const formData = new FormData(this.form);
      //   if (this.cart) {
      //     formData.append(
      //       'sections',
      //       this.cart.getSectionsToRender().map((section) => section.id)
      //     );
      //     formData.append('sections_url', window.location.pathname);
      //     this.cart.setActiveElement(document.activeElement);
      //   }
      //   config.body = formData;

      //   fetch(`${routes.cart_add_url}`, config)
      //     .then((response) => response.json())
      //     .then((response) => {
      //       if (response.status) {
      //         publish(PUB_SUB_EVENTS.cartError, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           errors: response.errors || response.description,
      //           message: response.message,
      //         });
      //         this.handleErrorMessage(response.description);

      //         const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      //         if (!soldOutMessage) return;
      //         this.submitButton.setAttribute('aria-disabled', true);
      //         this.submitButtonText.classList.add('hidden');
      //         soldOutMessage.classList.remove('hidden');
      //         this.error = true;
      //         return;
      //       } else if (!this.cart) {
      //         window.location = window.routes.cart_url;
      //         return;
      //       }

      //       const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      //       if (!this.error)
      //         publish(PUB_SUB_EVENTS.cartUpdate, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           cartData: response,
      //         }).then(() => {
      //           CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
      //         });
      //       this.error = false;
      //       const quickAddModal = this.closest('quick-add-modal');
      //       if (quickAddModal) {
      //         document.body.addEventListener(
      //           'modalClosed',
      //           () => {
      //             setTimeout(() => {
      //               CartPerformance.measure("add:paint-updated-sections", () => {
      //                 this.cart.renderContents(response);
      //               });
      //             });
      //           },
      //           { once: true }
      //         );
      //         quickAddModal.hide(true);
      //       } else {
      //         CartPerformance.measure("add:paint-updated-sections", () => {
      //           this.cart.renderContents(response);
      //         });
      //       }
      //     })
      //     .catch((e) => {
      //       console.error(e);
      //     })
      //     .finally(() => {
      //       this.submitButton.classList.remove('loading');
      //       if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      //       if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      //       this.querySelector('.loading__spinner').classList.add('hidden');

      //       CartPerformance.measureFromEvent("add:user-action", evt);
      //     });
      // }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );

  // OPTIMIZED VERSION - FASTER CART UPDATES WITH EMPTY CART FIX
  document.addEventListener('DOMContentLoaded', function() {
    const productForms = document.querySelectorAll('product-form form[data-type="add-to-cart-form"]');
    
    // Global listener – handles every product-form submit
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('product-form form[data-type="add-to-cart-form"]');
      if (!form) return;
      e.preventDefault();

      const submitBtn  = form.querySelector('button[type="submit"]');
      const spanLbl    = submitBtn.querySelector('span') || submitBtn;
      const defaultTxt = spanLbl.textContent;
      const wasDisabled= submitBtn.disabled;

      // Store if cart was empty before adding
      const cartDrawer = document.querySelector('cart-drawer');
      const cartCount = document.querySelector('.cart-count-bubble span[aria-hidden="true"]')?.textContent || '0';
      const wasEmpty = cartDrawer?.classList.contains('is-empty') || 
                       cartCount === '0' || 
                       cartCount === '' ||
                       document.querySelectorAll('.cart-count-bubble:not(.hidden)').length === 0;

      // Debug logging
      console.log('Cart add attempt:', {
        wasEmpty: wasEmpty,
        currentCount: cartCount,
        drawerExists: !!cartDrawer,
        drawerClasses: cartDrawer?.className
      });

      /* ----- busy state: add both ARIA props ----- */
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.disabled = true;
      submitBtn.classList.add('loading');

      // Hide any existing loading spinner and show it
      const spinner = submitBtn.querySelector('.loading__spinner');
      if (spinner) {
        spinner.classList.remove('hidden');
      }

      try {
        /* 1 — add to cart */
        const fd  = new FormData(form);
        const res = await fetch('/cart/add.js', { method:'POST', body:fd });
        
        if (!res.ok) {
          const errorData = await res.json();
          throw new Error(errorData.description || 'Add-to-cart failed');
        }

        /* 2 — parallel refresh */
        const [cart, drawer] = await Promise.all([
          fetch('/cart.js').then(r => r.json()),
          fetch('?sections=cart-drawer,cart-icon-bubble').then(r => r.json())
        ]);

        console.log('Cart updated:', {
          newCount: cart.item_count,
          wasEmpty: wasEmpty,
          cartData: cart
        });

        /* 3 — update UI */
        updateCartCountQuick(cart, wasEmpty);
        updateDrawerContent(drawer['cart-drawer'], wasEmpty);
        updateCartIconBubble(drawer['cart-icon-bubble']);
        openCartDrawerQuick();

        /* 4 — success flash */
        spanLbl.textContent = '✔ Added';
        await new Promise(r => setTimeout(r, 900));

      } catch (err) {
        console.error('Cart add error:', err);
        showError(form, err.message || 'Failed to add item to cart');
      } finally {
        /* ----- restore original state ----- */
        spanLbl.textContent  = defaultTxt;
        submitBtn.classList.remove('loading', 'is-added');
        submitBtn.removeAttribute('aria-busy');
        submitBtn.removeAttribute('aria-disabled');
        submitBtn.disabled = wasDisabled;

        // Hide loading spinner
        if (spinner) {
          spinner.classList.add('hidden');
        }
      }
    });
  });

  // Fixed cart count update - handles empty cart case
  function updateCartCountQuick(cart, wasEmpty) {
    console.log('Updating cart count:', cart.item_count, 'wasEmpty:', wasEmpty);

    // Update all cart count elements
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble .cart-count, [data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
    });
    
    // Show/hide cart count bubbles based on item count
    document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
      if (cart.item_count === 0) {
        bubble.classList.add('hidden');
        bubble.style.display = 'none';
      } else {
        bubble.classList.remove('hidden');
        bubble.style.display = '';
      }
    });

    // Special handling for when cart transitions from empty to having items
    if (wasEmpty && cart.item_count > 0) {
      // Force show all cart count elements
      document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
        bubble.classList.remove('hidden');
        bubble.style.display = '';
        bubble.removeAttribute('hidden');
      });

      // Update header cart elements
      const headerCarts = document.querySelectorAll('.header__icon--cart, .cart-link, [data-cart-link]');
      headerCarts.forEach(cart => {
        const bubble = cart.querySelector('.cart-count-bubble');
        if (bubble) {
          bubble.classList.remove('hidden');
          bubble.style.display = '';
        }
      });
    }

    // Update any cart empty states
    const cartElements = document.querySelectorAll('cart-drawer, .cart-drawer, [data-cart]');
    cartElements.forEach(cartEl => {
      if (cart.item_count > 0) {
        cartEl.classList.remove('is-empty', 'cart-empty');
      } else {
        cartEl.classList.add('is-empty', 'cart-empty');
      }
    });
  }

  // Fixed drawer content update - handles empty cart structure
  function updateDrawerContent(drawerHTML, wasEmpty) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || !drawerHTML) return;
    
    console.log('Updating drawer content, wasEmpty:', wasEmpty);
    
    // Remove empty cart classes
    cartDrawer.classList.remove('is-empty', 'cart-empty');
    
    const temp = document.createElement('template');
    temp.innerHTML = drawerHTML;
    
    // Try multiple selectors for drawer content
    const newContent = temp.content.querySelector('.drawer__inner') || 
                       temp.content.querySelector('.cart-drawer__content') ||
                       temp.content.querySelector('.cart-drawer') ||
                       temp.content.querySelector('[data-cart-drawer-content]') ||
                       temp.content.firstElementChild;
    
    let currentContent = cartDrawer.querySelector('.drawer__inner') || 
                         cartDrawer.querySelector('.cart-drawer__content') ||
                         cartDrawer.querySelector('[data-cart-drawer-content]');
    
    if (newContent) {
      if (currentContent) {
        // Replace existing content
        currentContent.replaceWith(newContent);
      } else {
        // If no existing content (empty cart), replace entire drawer content
        cartDrawer.innerHTML = '';
        cartDrawer.appendChild(newContent);
      }
    }

    // Update any cart totals in other parts of the page
    const cartTotals = document.querySelectorAll('.cart-drawer__total, .header__cart-total, [data-cart-total]');
    const newTotal = temp.content.querySelector('.cart-drawer__total, [data-cart-total]');
    if (newTotal) {
      cartTotals.forEach(total => {
        if (total !== newTotal) {
          total.innerHTML = newTotal.innerHTML;
        }
      });
    }
  }

  // Update cart icon bubble if it exists as a separate section
  function updateCartIconBubble(bubbleHTML) {
    if (!bubbleHTML) return;
    
    const temp = document.createElement('template');
    temp.innerHTML = bubbleHTML;
    
    const newBubble = temp.content.querySelector('.cart-count-bubble');
    const currentBubbles = document.querySelectorAll('.header .cart-count-bubble');
    
    if (newBubble && currentBubbles.length > 0) {
      currentBubbles.forEach(bubble => {
        bubble.outerHTML = newBubble.outerHTML;
      });
    }
  }

  // Enhanced drawer opening with empty cart handling
  function openCartDrawerQuick() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    console.log('Opening cart drawer');

    // Ensure drawer is no longer marked as empty
    drawer.classList.remove('is-empty', 'cart-empty');
    
    // Try different methods to open the drawer
    if (drawer.open && typeof drawer.open === 'function') {
      drawer.open();
    } else if (drawer.show && typeof drawer.show === 'function') {
      drawer.show();
    } else {
      // Manual opening
      drawer.classList.add('animate', 'active', 'open');
      drawer.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      
      // Focus management
      const firstFocusable = drawer.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) {
        setTimeout(() => firstFocusable.focus(), 100);
      }
    }
    
    // Trigger any custom drawer open events
    drawer.dispatchEvent(new CustomEvent('cart:opened', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
  }

  // Enhanced error display
  function showError(form, message = 'An error occurred') {
    console.error('Cart error:', message);
    
    const productForm = form.closest('product-form');
    let errorWrapper = productForm?.querySelector('.product-form__error-message-wrapper');
    
    if (!errorWrapper) {
      // Create error wrapper if it doesn't exist
      errorWrapper = document.createElement('div');
      errorWrapper.className = 'product-form__error-message-wrapper';
      errorWrapper.innerHTML = `<div class="product-form__error-message errors text-center">${message}</div>`;
      form.appendChild(errorWrapper);
    } else {
      const errorMessage = errorWrapper.querySelector('.product-form__error-message');
      if (errorMessage) {
        errorMessage.textContent = message;
      }
    }
    
    errorWrapper.hidden = false;
    errorWrapper.style.display = 'block';
    
    // Auto-hide after 5 seconds
    setTimeout(() => {
      errorWrapper.hidden = true;
      errorWrapper.style.display = 'none';
    }, 5000);
  }

  console.log('Enhanced cart system loaded - empty cart issues should be fixed');
}